__turbopack_context__.v({
  "term": "Term-module-scss-module__DJjzUW__term",
  "term__desc": "Term-module-scss-module__DJjzUW__term__desc",
  "term__icon": "Term-module-scss-module__DJjzUW__term__icon",
  "term__title": "Term-module-scss-module__DJjzUW__term__title",
});
